import {Link, useMatchRoute} from '@tanstack/react-router';
import {Tabs, TabsList, TabsTab} from '@/components/ui/tabs';

type Props = {
  organizerId: string;
};

/**
 * Events | Members tab control for the organizer page. Composes coss
 * Tabs with TanStack `<Link>` via Base UI's `render` prop so navigation,
 * prefetch, and back/forward all work as plain links — the active tab is
 * derived from the current route match. Hidden by the parent layout
 * when the organizer has no admins or members.
 */
export function OrganizerTabs({organizerId}: Props) {
  const matchRoute = useMatchRoute();
  const isMembers = !!matchRoute({
    to: '/organizer/$organizerId/members',
    params: {organizerId},
  });
  const value = isMembers ? 'members' : 'events';

  return (
    <div className="border-b border-neutral-200">
      <Tabs value={value}>
        <TabsList variant="underline">
          <TabsTab
            value="events"
            render={
              <Link
                to="/organizer/$organizerId"
                params={{organizerId}}
                activeOptions={{exact: true}}
              />
            }
          >
            Events
          </TabsTab>
          <TabsTab
            value="members"
            render={
              <Link
                to="/organizer/$organizerId/members"
                params={{organizerId}}
              />
            }
          >
            Members
          </TabsTab>
        </TabsList>
      </Tabs>
    </div>
  );
}
